/* global jQuery, $, _ */

jQuery.easing["jswing"] = jQuery.easing["swing"];

jQuery.extend(jQuery.easing, {
  def: "easeOutQuad",
  swing: function(x, t, b, c, d) {
    return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
  },
  easeInQuad: function(x, t, b, c, d) {
    return c * (t /= d) * t + b;
  },
  easeOutQuad: function(x, t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b;
  },
  easeInOutQuad: function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
    return (-c / 2) * (--t * (t - 2) - 1) + b;
  },
  easeInCubic: function(x, t, b, c, d) {
    return c * (t /= d) * t * t + b;
  },
  easeOutCubic: function(x, t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  },
  easeInOutCubic: function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
    return (c / 2) * ((t -= 2) * t * t + 2) + b;
  },
  easeInQuart: function(x, t, b, c, d) {
    return c * (t /= d) * t * t * t + b;
  },
  easeOutQuart: function(x, t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  },
  easeInOutQuart: function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
    return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
  },
  easeInQuint: function(x, t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
  },
  easeOutQuint: function(x, t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  },
  easeInOutQuint: function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t * t + b;
    return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
  },
  easeInSine: function(x, t, b, c, d) {
    return -c * Math.cos((t / d) * (Math.PI / 2)) + c + b;
  },
  easeOutSine: function(x, t, b, c, d) {
    return c * Math.sin((t / d) * (Math.PI / 2)) + b;
  },
  easeInOutSine: function(x, t, b, c, d) {
    return (-c / 2) * (Math.cos((Math.PI * t) / d) - 1) + b;
  },
  easeInExpo: function(x, t, b, c, d) {
    return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
  },
  easeOutExpo: function(x, t, b, c, d) {
    return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
  },
  easeInOutExpo: function(x, t, b, c, d) {
    if (t == 0) return b;
    if (t == d) return b + c;
    if ((t /= d / 2) < 1) return (c / 2) * Math.pow(2, 10 * (t - 1)) + b;
    return (c / 2) * (-Math.pow(2, -10 * --t) + 2) + b;
  },
  easeInCirc: function(x, t, b, c, d) {
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  },
  easeOutCirc: function(x, t, b, c, d) {
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  },
  easeInOutCirc: function(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return (-c / 2) * (Math.sqrt(1 - t * t) - 1) + b;
    return (c / 2) * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
  },
  easeInElastic: function(x, t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d) == 1) return b + c;
    if (!p) p = d * 0.3;
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else s = (p / (2 * Math.PI)) * Math.asin(c / a);
    return (
      -(
        a *
        Math.pow(2, 10 * (t -= 1)) *
        Math.sin(((t * d - s) * (2 * Math.PI)) / p)
      ) + b
    );
  },
  easeOutElastic: function(x, t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d) == 1) return b + c;
    if (!p) p = d * 0.3;
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else s = (p / (2 * Math.PI)) * Math.asin(c / a);
    return (
      a * Math.pow(2, -10 * t) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) +
      c +
      b
    );
  },
  easeInOutElastic: function(x, t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d / 2) == 2) return b + c;
    if (!p) p = d * (0.3 * 1.5);
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else s = (p / (2 * Math.PI)) * Math.asin(c / a);
    if (t < 1)
      return (
        -0.5 *
          (a *
            Math.pow(2, 10 * (t -= 1)) *
            Math.sin(((t * d - s) * (2 * Math.PI)) / p)) +
        b
      );
    return (
      a *
        Math.pow(2, -10 * (t -= 1)) *
        Math.sin(((t * d - s) * (2 * Math.PI)) / p) *
        0.5 +
      c +
      b
    );
  },
  easeInBack: function(x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  },
  easeOutBack: function(x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  },
  easeInOutBack: function(x, t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    if ((t /= d / 2) < 1)
      return (c / 2) * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    return (c / 2) * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
  },
  easeInBounce: function(x, t, b, c, d) {
    return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
  },
  easeOutBounce: function(x, t, b, c, d) {
    if ((t /= d) < 1 / 2.75) {
      return c * (7.5625 * t * t) + b;
    } else if (t < 2 / 2.75) {
      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
    } else if (t < 2.5 / 2.75) {
      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
    } else {
      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    }
  },
  easeInOutBounce: function(x, t, b, c, d) {
    if (t < d / 2)
      return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * 0.5 + b;
    return (
      jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b
    );
  }
});

// ##### EVENT ######

/*! Tiny Pub/Sub - v0.7.0 - 2013-01-29
 * https://github.com/cowboy/jquery-tiny-pubsub
 * Copyright (c) 2013 "Cowboy" Ben Alman; Licensed MIT */
(function($) {
  var o = $({});

  $.subscribe = function() {
    o.bind.apply(o, arguments);
  };

  $.unsubscribe = function() {
    o.unbind.apply(o, arguments);
  };

  $.publish = function() {
    o.trigger.apply(o, arguments);
  };
})(jQuery);

function $number(num) {
  if (!(this instanceof $number)) {
    return new $number(num);
  }

  this.numStr = num.toString();
}

$number.prototype.pad = function(digit) {
  var numStr = this.numStr;
  var zero = "0";

  return numStr.length >= digit
    ? numStr
    : new Array(digit - numStr.length + 1).join(zero) + numStr;
};

$number.prototype.comma = function() {
  var parts = this.numStr.split(".");

  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return parts.join(".");
};

$number.prototype.tags = function(classPrefix, suffixTag, isComma, isText) {
  var $tag = $("<b></b>");
  var numTags = $("<div/>"); // jQuery 1.5.x에선 documentFragment를 쓸 수 없음
  var prefix = classPrefix || "n";

  var numStr = isComma ? this.comma() : this.numStr;

  if (isText) {
    numStr = this.text.call({
      numStr: numStr
    });
  }

  $.each(numStr.split(""), function(k, val) {
    var s = "";

    if (val === ",") {
      s = "comma";
    } else if (val === "만") {
      s = "man";
    } else if (val === "억") {
      s = "eok";
    } else if (val === "조") {
      s = "jo";
    } else if (val.search(/[0-9]/) > -1) {
      s = val;
    } else {
      return;
    }

    $tag
      .clone()
      .addClass(prefix + s)
      .appendTo(numTags);
  });

  if (suffixTag) {
    $(suffixTag).appendTo(numTags);
  }

  return numTags.html();
};

$number.prototype.text = function(options) {
  var parts = this.numStr.split(".");
  var sep = [];
  var revalue = [];
  var unit = ["", "만", "억", "조"];

  options = $.extend(
    {
      delimiter: " ",
      comma: false
    },
    options
  );

  parts[0] = parts[0].replace(/,/g, "");
  parts[0] = parts[0].replace(/\B(?=(\d{4})+(?!\d))/g, ",");

  sep = parts[0].split(",");

  $.each(
    sep.reverse(),
    $.proxy(function(index, el) {
      el = parseInt(el, 10);

      if (el > 0) {
        el = options.comma
          ? this.comma.call({
              numStr: el.toString()
            })
          : el.toString();
        el = el + unit[index] + options.delimiter;
      } else {
        el = "";
      }

      revalue.push(el);
    }, this)
  );

  return $.trim(revalue.reverse().join(""));
};

var $ui = (function() {
  function log() {
    if (console) {
      Function.prototype.apply.call(console.log, console, arguments);
    }
  }

  function goTop() {
    $("html, body").scrollTop(0, 0);
  }

  function modal(show) {
    if (show) {
      $("#modalShadow").show();
    } else {
      $("#modalShadow").hide();
    }
  }

  // Fullscreen Popup
  var popup = (function() {
    function show(target) {
      $(".popup").show();
      $(target).show();
      $("html, body")
        .stop(true, true)
        .animate(
          {
            scrollTop: 0,
            easing: "easeOutCubic",
            queue: false
          },
          300
        );
    }

    function hide(target) {
      $(".popup").hide();
      $(target).hide();
    }

    return {
      show: show,
      hide: hide
    };
  })();

  // <div class="number-tags my-function-name" data-number-fn="myFunctionName" data-digit="3" data-prefix="n" data-max="999" data-suffix-tag="<span class='unit'/>"></div>
  function numberTagsFactory($elements) {
    $elements.each(function() {
      var $this = $(this);

      var name = $this.data("number-fn");
      var digit = parseInt($this.data("digit"), 10) || 0;
      var prefix = $this.data("prefix") || false;
      var suffixTag = $this.data("suffix-tag") || false;
      var numMax = $this.data("max") ? parseInt($this.data("max"), 10) : null;

      if ($ui[name]) {
        throw new Error(name + "은(는) $ui에 이미 정의되어 있는 함수입니다.");
      }

      $ui[name] = function(num) {
        if (numMax) {
          num = Math.min(num, numMax);
        }

        if (digit > 1) {
          num = $number(num).pad(digit);
        }

        $this.html($number(num).tags(prefix, suffixTag));
      };
    });
  }

  return {
    log: log,
    goTop: goTop,
    modal: modal,
    popup: popup,
    init: function() {
      numberTagsFactory($("[data-number-fn]"));

      $.subscribe("modal/popup/show", function() {
        goTop();
        modal(true);
      });

      $.subscribe("modal/popup/hide", function() {
        modal(false);
      });
    }
  };
})();

$(function() {
  $ui.init();

  // Scroll Event
  var $gnbEl = $("#gnb");
  var gnbOffSet = $gnbEl.offset();
  var $gnbBtns = $(".gnb-btns a");
  $(window).bind("scroll.event-default", function() {
    var windowTop = $(this).scrollTop();
    if ($(".scroll_value").length != 0) {
      $(".scroll_value").text(windowTop);
    }
    if (gnbOffSet.top < windowTop) {
      $gnbEl.addClass("fixed");
    } else {
      $gnbEl.removeClass("fixed");
    }

    var viewPoint = 400;
    if (windowTop >= 5848 - viewPoint) {
      $gnbBtns.removeClass("on");
      $gnbBtns.eq(3).addClass("on");
    } else if (windowTop >= 4208 - viewPoint) {
      $gnbBtns.removeClass("on");
      $gnbBtns.eq(2).addClass("on");
    } else if (windowTop >= 2568 - viewPoint) {
      $gnbBtns.removeClass("on");
      $gnbBtns.eq(1).addClass("on");
    } else if (windowTop >= 928 - viewPoint) {
      $gnbBtns.removeClass("on");
      $gnbBtns.eq(0).addClass("on");
      $(".btn-top").addClass("on");
    } else {
      $gnbBtns.removeClass("on");
      $(".btn-top").removeClass("on");
    }
  });

  $(".gnb-btns a, .btn-top, .btn-benefit").bind("click", function() {
    var tar = $(this).attr("href");
    var desOffset = $(tar).offset();
    $("html, body")
      .stop(true, false)
      .animate({ scrollTop: desOffset.top - 76 }, 1500, "easeInOutQuint");
    return false;
  });
});
